<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M2.50195 9.16667L17.502 5V15L2.50195 11.6667V9.16667Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.66579 13.9995C9.57824 14.3168 9.42904 14.6139 9.22671 14.8736C9.02438 15.1333 8.77287 15.3506 8.48656 15.5131C8.20025 15.6756 7.88473 15.7801 7.55802 15.8206C7.23131 15.8612 6.89982 15.837 6.58246 15.7495C6.26509 15.6619 5.96808 15.5127 5.70838 15.3104C5.44868 15.1081 5.23138 14.8566 5.06888 14.5702C4.90637 14.2839 4.80186 13.9684 4.76129 13.6417C4.72073 13.315 4.74491 12.9835 4.83246 12.6661"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconMotivator',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#EF7950'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
